@for (button of buttons; track button) {
  <div class="confirm-btns-item" [class]="button.class">
    <button
      appThrottleClick
      class="x_confirm-btn x_secondary"
      [disabled]="button.disabled"
      (throttledClick)="btnClick(button)"
    >
      {{ button.name | translate }}
    </button>
  </div>
}
